import { render, staticRenderFns } from "./CountLeadChart.vue?vue&type=template&id=0b6000af"
import script from "./CountLeadChart.vue?vue&type=script&lang=js"
export * from "./CountLeadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports